module.exports = __webpack_public_path__ + "FirmaFRS.jpg?75aa1a2fbcc3550777d8f701d8fe7401";


//////////////////
// WEBPACK FOOTER
// ./src/assets/FirmaFRS.jpg
// module id = 2085
// module chunks = 2